import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useContext } from "react";
import GenericPermissionContext from "../../contexts/GenericPermissionContext";
import CustomFooterGraphic from "../Requests/CustomFooterGraphic";
import AdminActiveUsers from "./AdminActiveUsers";
import AdminDataPoints from "./AdminDataPoints";
import AdminRequests from "./AdminRequests";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontFamily: "Proxima Nova",
    margin: theme.spacing(3),
  },
  marginBottom2: {
    marginBottom: theme.spacing(2),
  },
}));

interface AdminStatisticsProps {}

const AdminStatistics: React.FC<AdminStatisticsProps> = () => {
  const classes = useStyles();
  const { viewAdditionalStatistics } = useContext(GenericPermissionContext);

  return (
    <div className={classes.root}>
      <h2>Administration Area </h2>
      <AdminActiveUsers className={classes.marginBottom2} />
      {viewAdditionalStatistics && (
        <>
          <AdminRequests className={classes.marginBottom2} />
          <AdminDataPoints className={classes.marginBottom2} />
        </>
      )}
      <CustomFooterGraphic />
    </div>
  );
};

export default AdminStatistics;
